import { useEffect } from 'react';
import tagsSagaWatcher from '../store/sagas';
import tagsReducer from '../store';
import { injectSaga } from '@app/store/rootSaga';
import { injectReducer } from '@app/store';

export const useTagsChunk = () => {
    useEffect(() => {
        injectReducer('tags', tagsReducer);
        injectSaga('tags', tagsSagaWatcher);
    }, []);
};
